function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00c763;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fundo_morango",
  "data-name": "Fundo morango"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M29.23,36.8c2.34,2.59,1.64,7-1.54,9.89s-7.66,3.1-10,.51-1.64-7,1.55-9.89S26.9,34.21,29.23,36.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M78.75,36.8c2.33,2.59,1.64,7-1.55,9.89s-7.66,3.1-10,.51-1.64-7,1.55-9.89S76.42,34.21,78.75,36.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M17.21,0,15.75,7H4.63L4,10H15.13l-.83,4H6.63L6,17h7.67l-.83,4H.62L0,24H58.73l5-24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M89,24.8l-4.46-4a2.93,2.93,0,0,1-1-2.1L83,11.8A6.29,6.29,0,0,0,76.48,6h-10L63.56,20l-1.25,6L59,42h4c1.15-5.5,6.59-10,12.09-10S84.12,36.5,83,42a5.21,5.21,0,0,0,4.84-4L89.9,28A3.29,3.29,0,0,0,89,24.8ZM67.56,20l2.09-10h6a3,3,0,0,1,3.19,2.79v.11l.57,6.9c0,.1.08.1.06.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M8.46,42h5c1.15-5.5,6.59-10,12.09-10s9.06,4.5,7.91,10H55L57.9,28H11.38Z"
}))));

function SvgEntrega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrega);
export default __webpack_public_path__ + "static/media/Entrega.7e73c919.svg";
export { ForwardRef as ReactComponent };